module.exports = __webpack_public_path__ + "img/DynamicFormOutlined.2c5427e9.svg";